// gallery-lightbox.js — load once via <script src> in App.razor or the component
(function () {
    if (window.GalleryLightbox) return;

    // State per gallery, keyed by id. Populated lazily on first open/click.
    var _galleries = {};
    var _current = {};

    // Read srcs straight from the DOM data attribute — always fresh, no stale state.
    function _getSrcs(id) {
        var el = document.getElementById('lb-data-' + id);
        if (!el) return null;
        try { return JSON.parse(el.getAttribute('data-srcs') || '[]'); }
        catch (e) { return null; }
    }

    function open(imgEl) {
        var id = imgEl.getAttribute('data-gallery');
        var idx = parseInt(imgEl.getAttribute('data-index'), 10);

        // Always re-read from DOM — guarantees we never use stale data from a prev page
        var srcs = _getSrcs(id);
        if (!srcs || !srcs.length) return;

        _galleries[id] = srcs;
        _current[id] = idx;
        _show(id);
    }

    function close(id) {
        var modal = document.getElementById('lb-' + id);
        if (modal) modal.style.display = 'none';
    }

    function prev(id) { _change(id, -1); }
    function next(id) { _change(id, 1); }

    function handleOverlayClick(e, id) {
        if (e.target === document.getElementById('lb-' + id)) close(id);
    }

    function _show(id) {
        var modal = document.getElementById('lb-' + id);
        var img = document.getElementById('lb-img-' + id);
        if (!modal || !img) return;
        img.src = _galleries[id][_current[id]];
        modal.style.display = 'flex';
    }

    function _change(id, dir) {
        var img = document.getElementById('lb-img-' + id);
        if (!img || !_galleries[id]) return;
        img.classList.add('fade-out');
        setTimeout(function () {
            var len = _galleries[id].length;
            _current[id] = ((_current[id] + dir) % len + len) % len;
            img.src = _galleries[id][_current[id]];
            img.classList.remove('fade-out');
        }, 250);
    }

    // On navigation just wipe in-memory state — next open() will re-read from DOM
    function _clearAll() {
        _galleries = {};
        _current = {};
    }

    document.addEventListener('enhancedload', _clearAll);
    document.addEventListener('blazor:navigated', _clearAll);
    window.addEventListener('popstate', _clearAll);

    document.addEventListener('keydown', function (e) {
        var openId = Object.keys(_galleries).find(function (id) {
            var m = document.getElementById('lb-' + id);
            return m && m.style.display !== 'none';
        });
        if (!openId) return;
        if (e.key === 'ArrowRight') next(openId);
        if (e.key === 'ArrowLeft') prev(openId);
        if (e.key === 'Escape') close(openId);
    });

    window.GalleryLightbox = { open: open, close: close, prev: prev, next: next, handleOverlayClick: handleOverlayClick };
})();